<template>
    <div class="border rounded p-3 mb-3 bg-light">
        <h6><i class="fas fa-sync-alt mr-1" aria-hidden="true"></i> Регулярные заявки</h6>
        <b-form-checkbox :checked="settings.enabled" switch @change="set('enabled', $event)">Разрешить регулярные заявки</b-form-checkbox>
        <p class="small text-muted mt-2">Инициатор сможет выбрать разовую заявку или серию по графику. Каждое повторение создаётся отдельной заявкой.</p>
        <template v-if="settings.enabled">
            <b-form-group label="Согласование">
                <b-form-select :value="settings.approvalMode" :options="modes" @change="set('approvalMode', $event)" />
            </b-form-group>
            <p class="small text-muted">Для типов с действиями над справочником при согласовании выбирайте согласование каждой заявки. Изменение режима применяется к новым сериям.</p>
            <b-form-group label="Создавать заранее, календарных дней" description="Значение по умолчанию; его можно изменить в серии.">
                <b-form-input type="number" min="0" max="365" :value="settings.leadDays" @input="set('leadDays', Number($event))" />
            </b-form-group>
            <h6>Кто управляет сериями</h6>
            <MultipleParticipantsConfig :value="settings.managers" :users="users" :departments="departments"
                participant-label="управляющего серией" :show-object-roles="true" :show-request-roles="true" :show-priority="false" :show-fallback-option="false"
                hint-text="Эти участники могут приостанавливать, возобновлять, останавливать серии и менять их условия. Роль в заявке учитывается в текущей редакции серии и её повторениях; право появляется после назначения участника."
                empty-text="Добавьте хотя бы одно правило управления сериями." @input="set('managers', $event)" />
        </template>
    </div>
</template>
<script>
import MultipleParticipantsConfig from '../RequestTypes/MultipleParticipantsConfig/MultipleParticipantsConfig.vue';
const recurrence = require('@/utils/requestRecurrence');
export default {
    components: {MultipleParticipantsConfig},
    props: {value: Object, users: {type: Array, default: () => []}, departments: {type: Array, default: () => []}},
    computed: {
        settings() { return recurrence.config({workflow_config: {recurrence: this.value}}); },
        modes() { return [{value: 'once', text: 'Согласовать серию один раз'}, {value: 'each', text: 'Согласовывать каждую заявку'}]; }
    },
    methods: {set(key, value) { this.$emit('input', {...this.settings, [key]: value}); }}
};
</script>
